import React, { memo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { fillLicenseText, formatLicenseDate } from "../../utils/LicenseExpire";
import { levelColors, SENT_COLORS } from "./licenseStyle";

//จอแคบกว่า 576px (จุดเดียวกับ d-sm-* ของ bootstrap) แถบด้านบนเหลือที่ประมาณ 300px
//ป้ายต้องย่อเหลือ "● 7 วัน" ไม่งั้นกระดิ่งแจ้งเตือนถูกดันตกไปบรรทัดที่สอง
const PHONE = "@media (max-width: 575.98px)";

//แถบด้านบนเป็นสีส้ม จึงใช้พื้นขาว แล้วบอกระดับความเร่งด่วนด้วยจุดสีหน้าข้อความ
const useStyles = makeStyles({
  chip: {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    margin: "0 8px 0 4px",
    padding: "5px 12px 5px 10px",
    border: 0,
    borderRadius: 999,
    background: "#ffffff",
    color: "#1f2937",
    fontSize: 13,
    lineHeight: "18px",
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover": { background: "#f3f4f6" },
    "&:focus": { outline: "none" },
    "&:focus-visible": { boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.7)" },
    [PHONE]: { margin: "0 2px 0 0", padding: "4px 8px 4px 6px" },
  },
  dot: { width: 8, height: 8, borderRadius: "50%", marginRight: 6, flexShrink: 0, [PHONE]: { marginRight: 4 } },
  label: { marginRight: 4 },
  strong: { fontWeight: 500 },
  sent: { marginLeft: 6, fontSize: 14, color: SENT_COLORS.ink },
});

/** ป้ายจำนวนวันที่เหลือบนแถบด้านบน — กดเพื่อเปิด popup (จอแคบซ่อนคำว่า License) */
const LicenseChip = ({ status, t, onClick }) => {
  const classes = useStyles();
  const colors = levelColors(status.level);

  let text;
  if (status.isExpired) {
    text = <span className={classes.strong} style={{ color: colors.ink }}>{t("ISA_License_Chip_Expired", "หมดอายุแล้ว")}</span>;
  } else if (status.remainingDays === 0) {
    text = <span className={classes.strong} style={{ color: colors.ink }}>{t("ISA_License_Chip_LastDay", "หมดอายุวันนี้")}</span>;
  } else {
    const [before, after = ""] = t("ISA_License_Chip_Remaining", "เหลือ {days} วัน").split("{days}");
    text = (
      <span>
        <span className="d-none d-sm-inline">{before}</span>
        <span className={classes.strong} style={{ color: colors.ink }}>{status.remainingDays}</span>
        {after}
      </span>
    );
  }

  const expireOn = fillLicenseText(t("ISA_License_ExpireOn", "หมดอายุวันที่ {date}"), {
    date: formatLicenseDate(status.expireDate),
  });

  return (
    <button type="button" className={classes.chip} onClick={onClick} title={`License ${expireOn}`}>
      <span className={classes.dot} style={{ background: colors.dot }} />
      <span className={`d-none d-sm-inline ${classes.label}`}>License</span>
      {text}
      {status.renewRequest ? (
        <i className={`zmdi zmdi-check d-none d-sm-inline ${classes.sent}`} title={t("ISA_License_Chip_Requested", "ส่งคำขอต่ออายุแล้ว")} />
      ) : null}
    </button>
  );
};

LicenseChip.propTypes = {
  status: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default memo(LicenseChip);
